import script from './component-lib.esm2.js';
export { PaperProps } from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.component, _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-paper",
    style: _vm.styles
  }, 'component', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-910937fa_0", {
    source: ".v-paper[data-v-910937fa]{background-color:var(--c-color,#fff);box-shadow:var(--c-shadow,none);border:var(--c-border-width) solid var(--c-border-color);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));display:block;position:relative;text-decoration:none;z-index:1}.v-paper[data-v-910937fa]::before{content:\"\";border-radius:inherit;opacity:0;transition:opacity .3s ease-in-out;z-index:-1;position:absolute;top:0;right:0;bottom:0;left:0;box-shadow:var(--c-shadow-hover)}.v-paper[data-v-910937fa]:hover::before{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-910937fa";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Paper = __vue_component__;
export { Paper as default };